import { gradientModelManager } from './gradient-model-manager';
export function getNextActiveStopId({ deletedStopId, stops }) {
  const deletedStop = stops.find((stop) => stop.id === deletedStopId);
  const remainingStops = stops.filter((stop) => stop.id !== deletedStopId);

  if (remainingStops.length === 0) {
    return null;
  }

  const remainingStopsSorted = [...remainingStops].sort(
    (a, b) =>
      gradientModelManager.extractStopPosition(a) - gradientModelManager.extractStopPosition(b)
  );
  const deletedPosition = deletedStop
    ? gradientModelManager.extractStopPosition(deletedStop)
    : Number.POSITIVE_INFINITY;

  const leftCandidate = [...remainingStopsSorted]
    .reverse()
    .find((stop) => gradientModelManager.extractStopPosition(stop) < deletedPosition);
  const rightCandidate = remainingStopsSorted.find(
    (stop) => gradientModelManager.extractStopPosition(stop) > deletedPosition
  );

  return leftCandidate?.id ?? rightCandidate?.id ?? remainingStopsSorted[0].id;
}
